import type { OrganizationRecord } from "../../api/organizations";

export const formatDate = (d: Date | null) =>
  d ? d.toLocaleDateString(undefined, { dateStyle: "medium" }) : "—";

export const formatDaysFromNow = (date: Date | null): string => {
  if (!date) return "Not scheduled";
  const diffDays = Math.ceil((date.getTime() - Date.now()) / 86400000);
  if (diffDays === 0) return "Due today";
  if (diffDays < 0) return `${Math.abs(diffDays)}d overdue`;
  return `In ${diffDays}d`;
};

/** Statuses that mean the plan is no longer in good standing. */
const EXPIRED_SUBSCRIPTION_STATUSES = new Set([
  "canceled",
  "unpaid",
  "incomplete_expired",
]);

/**
 * True when the org's plan period has ended or billing status is expired-like.
 * Used to highlight rows for human/agent renewal outreach.
 */
export const isPlanExpired = (org: OrganizationRecord): boolean => {
  const status = org.subscriptionStatus;
  if (status && EXPIRED_SUBSCRIPTION_STATUSES.has(status)) {
    return true;
  }
  if (
    org.currentPeriodEnd &&
    org.currentPeriodEnd.getTime() < Date.now() &&
    status !== "trialing"
  ) {
    return true;
  }
  return false;
};

export const getReasonToCall = (r: OrganizationRecord): string => {
  if (r.planId == null) return "Unassigned – no plan set";
  if (
    r.subscriptionStatus === "past_due" ||
    r.subscriptionStatus === "unpaid" ||
    r.subscriptionStatus === "pending_ves"
  )
    return "Payment issue";
  if (r.subscriptionStatus === "trialing") return "Trial follow-up";
  return "Needs follow-up";
};

export const isNeedsCalling = (r: OrganizationRecord): boolean => {
  if (!r.email && !r.phone) return false;
  if (r.subscriptionStatus === "active" || r.subscriptionStatus === "canceled")
    return false;
  return true;
};
